import useGoToBrowse from './useGoToBrowse';

export default useGoToBrowse;
